import React, { useState, useEffect } from "react";
import { Spinner } from "react-bootstrap";
import {
  Accordion,
  Button,
  Card,
  Col,
  Container,
  Form,
  Modal,
  Navbar,
  Row,
  Table,
} from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import { useLocation, useParams } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa";
import { GrUpdate } from "react-icons/gr";
import { BiUpload } from "react-icons/bi";
import imageCompression from "browser-image-compression";
import ShowRefImage from "./ShowRefImage";
import ShowWorkImage from "./ShowWorkImage";

const TrackOrder = () => {

  const API_URL = "https://akulcreations.com/api/AkulCreationsAPI.php";


  const [blist, setBlist] = useState([]);
  const [wlist, setWlist] = useState([]);
  const [notFound, setNotFound] = useState(false);
  const [isDelivered, setIsDelivered] = useState(false);
  const [images, setImages] = useState([]);
  const [show, setShow] = useState(false);
  const [updatedButton, setUpdatedButton] = useState(false);
  const toggle = () => setShow(!show);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const billId = queryParams.get('id');

  const [loading, setLoading] = useState(false);

  console.log(billId);

  useEffect(() => {
    if (!billId) return;
    getBillData();
    getWorkedData();
  }, [billId]);

  useEffect(() => {
    setImages(blist.images || []);
  }, [blist]);

  useEffect(() => {
    if (
      parseInt(blist?.balance) === 0 &&
      parseInt(blist.receivedAmount) === parseInt(blist.total) &&
      blist?.orderStatus === "Delivered"
    ) {
      setIsDelivered(true);
    }
  }, [blist]);

  function getBillData() {
    const formData = new FormData();
    formData.append("tag", "GetOrderDataByBill");
    formData.append("billId", billId);

    axios.post(API_URL, formData)
      .then((res) => {

        // ✅ FIX 1: Extract array properly
        const orders = Array.isArray(res.data)
          ? res.data
          : Array.isArray(res.data.data)
            ? res.data.data
            : [];

        if (orders.length === 0) {
          setNotFound(true);
          return;
        }

        const aggregatedData = orders.reduce((accumulator, order) => {
          const { id, price, quantity, itemData, generateOrder } = order;

          if (!generateOrder) return accumulator;

          const {
            billId,
            estimateDate,
            description,
            advance,
            balance,
            total,
            billDate,
            orderStatus,
            userProfile
          } = generateOrder;

          if (!accumulator[billId]) {
            accumulator[billId] = {
              billId,
              estimateDate,
              description,
              advance,
              balance,
              total,
              billDate,
              orderStatus,
              userProfile,
              items: []
            };
          }

          accumulator[billId].items.push({
            id,
            price,
            quantity,
            itemData
          });

          return accumulator;
        }, {});

        const reducedData = Object.values(aggregatedData)[0];

        if (reducedData) {
          setBlist(reducedData);

          if (reducedData.orderStatus === "Delivered") {
            setIsDelivered(true);
          }
        }
      })
      .catch((error) => {
        setNotFound(true);
        console.error(error);
      });
  }

  function getWorkedData() {
    const formData = new FormData();
    formData.append("tag", "GetWorkAssignByBill");
    formData.append("billId", billId);

    axios.post(API_URL, formData)
      .then((res) => {

        // ✅ SAFE ARRAY EXTRACTION
        const orders = Array.isArray(res.data)
          ? res.data
          : Array.isArray(res.data?.data)
            ? res.data.data
            : [];

        if (orders.length === 0) {
          setWlist(null);
          return;
        }

        const aggregatedData = orders.reduce((accumulator, order) => {

          const {
            id,
            workStatus,
            quantity,
            empPay,
            workAssignDate,
            workCompletedDate,
            categoryWorkData,
            employeeWorkData,
            itemWorkData,
            generateOrderWorkData,
            barcode,
          } = order;

          // 🔒 SAFETY CHECK
          if (!generateOrderWorkData) return accumulator;

          const {
            billId,
            estimateDate,
            description,
            advance,
            balance,
            total,
            billDate,
            orderStatus,
            userProfile,
          } = generateOrderWorkData;

          const category = categoryWorkData?.categoryName || "Unknown";

          if (!accumulator[billId]) {
            accumulator[billId] = {
              billId,
              estimateDate,
              description,
              advance,
              balance,
              total,
              billDate,
              orderStatus,
              userProfile,
              items: [],
            };
          }

          accumulator[billId].items.push({
            id,
            workStatus,
            quantity,
            empPay,
            workAssignDate,
            workCompletedDate,
            categoryWorkData,
            employeeWorkData,
            itemWorkData,
            category,
            barcode,
          });

          return accumulator;
        }, {});

        const rData = Object.values(aggregatedData)[0];

        if (rData) {
          const deliveryStatus =
            rData.orderStatus === "Delivered" ||
            rData.items.some(
              (item) => item.categoryWorkData?.categoryName === "Delivered"
            );

          setIsDelivered(deliveryStatus);
          setWlist(rData);
        }
      })
      .catch((error) => {
        toast.error("Error fetching items");
        console.error(error);
      });
  }



  const [selectedBillId, setSelectedBillId] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const handleShow = (billId) => {
    setSelectedBillId(billId);
    setShowModal(true);
  };

  const handleClose = () => {
    setSelectedBillId(null);
    setShowModal(false);
  };

  const updateImage = () => {
    setLoading(true);

    // only new images (no id yet)
    const newImages = images.filter((img) => !img.id);

    if (newImages.length === 0) {
      setLoading(false);
      return;
    }

    const formData = new FormData();
    formData.append("tag", "UploadOrderImages");
    formData.append("billId", blist.billId);

    // PHP expects images as JSON string
    formData.append(
      "images",
      JSON.stringify(
        newImages.map((img) => ({
          image: img.image,
          description: img.description,
          uploaded: img.uploaded,
          date: img.date,
          options: img.options,
          item: { id: img.item.id }
        }))
      )
    );

    axios
      .post(API_URL, formData)
      .then((res) => {
        setImages([]);        // clear local new images 
        getBillData();        // reload bill data
        toast.success("Image uploaded successfully!");
        setUpdatedButton(false);
        setLoading(false);
      })
      .catch((error) => {
        toast.error("Error updating images");
        console.error(error);
        setUpdatedButton(false);
        setLoading(false);
      });
  };


  if (notFound) {
    return (
      <Container
        className="text-center d-flex flex-column justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <Row>
          <Col>
            <h1 className="text-danger">Oops! Page not found</h1>
            <p>We couldn't find the order you were looking for.</p>
          </Col>
        </Row>
      </Container>
    );
  }

  return (
    <>
      <Navbar expand="lg" className="bg-dark">
        <Container>
          <Navbar.Brand className="fs-4 text-light">AKUL CREATION</Navbar.Brand>
        </Container>
      </Navbar>
      <div className="text-center card w-75 mx-auto mt-3">
        <h4 className="my-3 text-danger">
          THANK YOU FOR CHOOSING AKUL CREATION
        </h4>
        <h5 className="mb-3 ">FOR ANY QUERIES, CALL US @ 8951088742 </h5>
        <p className="mb-3 text-danger fw-bold">
          CALL TIMINGS - 11:30 AM to 7:30 PM - SUNDAY HOLIDAY
        </p>
      </div>

      <Container className="mx-auto my-5 col-lg-10 col-md-12 cl-sm-12 ">
        <div>
          <div>
            <Card className="p-3">
              <h4 className="text-center text-danger">Estimated Bill</h4>
              <div className="d-flex justify-content-between my-1">
                <p>
                  <strong>Est.Bill No. : </strong>
                  {blist.billId}
                </p>
                <p>
                  <strong>Bill Date : </strong>
                  {blist.billDate}
                </p>
              </div>
              <p>
                <strong>Customer Name : </strong>
                {blist.userProfile && blist.userProfile.name}
              </p>
              <p>
                <strong>Mobile : </strong>
                {blist.userProfile && blist.userProfile.mobile}
              </p>
              <Table striped bordered hover>
                <thead className="text-center">
                  <tr>
                    <th>Item</th>
                    <th>Quantity</th>
                    <th>Price</th>
                    <th>Sum</th>
                  </tr>
                </thead>
                <tbody className="text-center">
                  {blist.items &&
                    blist.items.map((item, index) => (
                      <tr key={index}>
                        <td>{item.itemData.item}</td>
                        <td>{item.quantity}</td>
                        <td>{item.price}</td>
                        <td>{item.quantity * item.price}</td>
                      </tr>
                    ))}
                </tbody>
                <tfoot className="text-center">
                  <tr>
                    <th style={{ textAlign: "right" }} colSpan="3">
                      Total
                    </th>
                    <td>{blist.total}</td>
                  </tr>
                  <tr>
                    <th style={{ textAlign: "right" }} colSpan="3">
                      Advance
                    </th>
                    <td>{blist.advance}</td>
                  </tr>
                  <tr>
                    <th style={{ textAlign: "right" }} colSpan="3">
                      Balance
                    </th>
                    <td>{blist.balance}</td>
                  </tr>
                  <tr className="text-start">
                    <th style={{ textAlign: "right" }}>Images:</th>
                    {blist.orderStatus !== "Canceled" && (
                      <td colSpan="2">
                        {images?.length == 0 && (
                          <Row className="my-4 ">
                            <div className="col-6 d-flex justify-content-center">
                              <div
                                role="button"
                                className="btn btn-outline-danger"
                                onClick={() => handleShow(blist.billId)}
                              >
                                View Images
                              </div>
                              {selectedBillId === blist.billId && (
                                <ShowRefImage
                                  billId={blist.billId}
                                  show={showModal}
                                  onHide={handleClose}
                                  status={blist.orderStatus}
                                />
                              )}
                            </div>

                            <div className="col-6 d-flex justify-content-center">
                              <Button
                                id="btn"
                                variant="danger"
                                onClick={toggle}
                                className="d-flex align-items-center gap-1"
                              >
                                Upload Design <BiUpload size={"1.1rem"} />
                              </Button>
                              {show && (
                                <ImageModal
                                  show={show}
                                  toggle={toggle}
                                  images={images}
                                  setImages={setImages}
                                  items={blist?.items}
                                  setUpdatedButton={setUpdatedButton}
                                />
                              )}
                            </div>
                          </Row>
                        )}




                        {updatedButton && (
                          <Button
                            variant="danger"
                            onClick={updateImage}
                            disabled={loading} // Disable button while loading
                          >
                            {loading ? (
                              <>
                                <Spinner
                                  as="span"
                                  animation="border"
                                  size="sm"
                                  role="status"
                                  aria-hidden="true"
                                />
                                &nbsp;Updating...
                              </>
                            ) : (
                              "Update"
                            )}
                          </Button>
                        )}






                      </td>
                    )}
                  </tr>
                  <tr>
                    <th style={{ textAlign: "right" }} >
                      Note :
                    </th>
                    <td colSpan="2">{blist.description || "No Note"}</td>
                  </tr>
                </tfoot>
              </Table>
              <p className="text-danger fw-2">
                {!isDelivered ? (
                  <b>
                    {blist?.estimateDate
                      ? `Estimated Delivery Date: ${blist.estimateDate}`
                      : "Order Status : Order Canceled"}
                  </b>
                ) : (
                  <p className="fw-bold text-success">
                    {" "}
                    Delivery Status : Delivered





                  </p>
                )}
              </p>
              <img src={blist?.image} />
            </Card>
            {wlist && wlist.items && wlist.items.length > 0 && (
              <Accordion defaultActiveKey={null} className="my-3">
                {Object.values(
                  wlist.items.reduce((itemGroups, data) => {
                    const key = `${data?.itemWorkData?.item}_${data?.barcode}`; // Group by item name and barcode
                    if (!itemGroups[key]) {
                      itemGroups[key] = [];
                    }
                    itemGroups[key].push(data);
                    return itemGroups;
                  }, {})
                ).map((itemGroup, index) => {
                  // Find the last category name
                  const lastCategory =
                    itemGroup[itemGroup.length - 1]?.categoryWorkData
                      ?.categoryName || itemGroup[0].itemWorkData?.item;

                  const bgColors = [
                    "#d4edda", // Light green for Completed
                    "#fff3cd", // Light yellow for In Progress
                    "#f8d7da", // Light red for Pending
                    "#cce5ff", // Light blue for On Hold
                    "#f5c6cb", // Light pink for Cancelled
                  ];


                  return (
                    <Accordion.Item key={index} eventKey={index.toString()}>
                      <Accordion.Header>
                        <div
                          style={{
                            backgroundColor: bgColors[index % bgColors.length],
                            padding: "10px", // Adjust padding as needed
                            width: "100%", // Ensure the background covers the full width
                          }}
                          className="d-flex justify-content-between"
                        >
                          <h6 className="text-center">
                            Work Status - {itemGroup[0].itemWorkData?.item}{" "}
                            (Barcode: {itemGroup[0].barcode})
                          </h6>
                          <span>
                            <strong>Status : </strong>
                            {lastCategory}
                          </span>
                          {/* <ShowWorkImage
                            barcode={itemGroup
                              .map((item) => item?.barcode)
                              .join(",")}
                          /> */}
                        </div>
                      </Accordion.Header>
                      <Accordion.Body>
                        <Table striped bordered responsive hover className="text-center">
                          <thead>
                            <tr>
                              <th>Assigned Date</th>
                              <th>Completed Date</th>

                              <th>Category</th>
                              <th>Status</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            {itemGroup.map((data, innerIndex) => (
                              <tr key={innerIndex}>
                                <td>{data.workAssignDate}</td>
                                <td>{data.workCompletedDate || "-"}</td>
                                <td>
                                  {data.categoryWorkData
                                    ? data.categoryWorkData.categoryName
                                    : itemGroup[0].itemWorkData?.item}
                                </td>
                                <td>{data.workStatus}</td>
                                <td>
                                  {data.workStatus === "Completed" ? (
                                    <FaCheckCircle color="green" size="25" />
                                  ) : (
                                    <GrUpdate color="orange" size="25" />
                                  )}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </Accordion.Body>
                    </Accordion.Item>
                  );
                })}
              </Accordion>
            )}
          </div>
        </div>
      </Container>
    </>
  );
};

export default TrackOrder;

function ImageModal({ show, toggle, setImages, items, setUpdatedButton }) {
  const [image, setImage] = useState(null);
  const [desc, setDesc] = useState("");
  const [selectedItem, setSelectedItem] = useState("");
  const [selectedOptions, setSelectedOptions] = useState([]);

  //remove duplicate items
  const itemsArr = items.reduce((accumulator, current) => {
    if (
      !accumulator.some((obj) => obj?.itemData?.id === current?.itemData?.id)
    ) {
      accumulator.push(current);
    }
    return accumulator;
  }, []);

  const handleImageChange = async (e) => {
    let file = e.target.files[0] || "";
    const options = {
      maxSizeMB: 0.5, // Max size in MB
      maxWidthOrHeight: 800, // Resize the image
      useWebWorker: true, // Use a web worker for compression
    };

    try {
      // Compress the image
      const compressedFile = await imageCompression(file, options);

      // Convert the compressed image to a Data URL
      const reader = new FileReader();
      reader.readAsDataURL(compressedFile);
      reader.onload = () => {
        setImage(reader.result);
      };
    } catch (error) {
      console.error("Error compressing the image:", error);
    }
  };
  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;
    if (checked) {
      // Add the selected option to the array
      setSelectedOptions((prev) => [...prev, value]);
    } else {
      // Remove the option if unchecked
      setSelectedOptions((prev) => prev.filter((option) => option !== value));
    }
  };

  // const handleClick = () => {
  //   if (!image)
  //     return toast.error("Please select an image ");

  //     const selectedOptionsString = selectedOptions.join(", "); 

  //     const currentDateTime = new Date().toLocaleString("en-IN", {
  //       day: "2-digit",
  //       month: "2-digit",
  //       year: "numeric",
  //       hour: "2-digit",
  //       minute: "2-digit",
  //       hour12: true,
  //     });

  //   setImages((prev) => [
  //     ...prev,
  //     {
  //       id: null, // Ensure the new images don't have an ID yet
  //       item: { id: parseInt(selectedItem) },
  //       image,
  //       description: desc,
  //       options: selectedOptionsString,
  //       uploaded:"Customer",
  //       date:currentDateTime
  //     },
  //   ]);
  //   toggle();
  //   setImage(null);
  //   setDesc("");
  //   setSelectedItem(""); // Clear the selected item
  //   setUpdatedButton(true);
  // };

  const base64ToBlob = (base64, mimeType = "image/jpeg") => {
    const byteString = atob(base64.split(",")[1]);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const uint8Array = new Uint8Array(arrayBuffer);

    for (let i = 0; i < byteString.length; i++) {
      uint8Array[i] = byteString.charCodeAt(i);
    }

    return new Blob([arrayBuffer], { type: mimeType });
  };

  const handleClick = async () => {
    if (!image) {
      toast.error("Please select an image.");
      return;
    }

    // Validate image format
    if (typeof image !== "string" || !image.startsWith("data:image")) {
      console.error("Invalid image format:", image);
      toast.error("Invalid image format!");
      return;
    }

    try {
      let fileToCompress = base64ToBlob(image); // Convert base64 to Blob

      // Check the image size
      const fileSizeMB = fileToCompress.size / (1024 * 1024); // Convert size to MB
      if (fileSizeMB > 15) {
        toast.error("Image size exceeds 15MB. Please upload a smaller image.");
        return;
      }

      // Compress the image
      const options = {
        maxSizeMB: 2, // Compress to a maximum of 2MB
        maxWidthOrHeight: 800, // Resize dimensions
        useWebWorker: true, // Use web worker for performance
      };
      const compressedImage = await imageCompression(fileToCompress, options);

      // Convert the compressed Blob back to base64
      const reader = new FileReader();
      reader.readAsDataURL(compressedImage);
      reader.onloadend = () => {
        const compressedBase64 = reader.result;

        // Format the current date and time
        const currentDateTime = new Date().toLocaleString("en-IN", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });

        const selectedOptionsString = selectedOptions.join(", ");

        // Add compressed image to the state
        setImages((prev) => [
          ...prev,
          {
            id: null, // Ensure the new images don't have an ID yet
            item: { id: parseInt(selectedItem) },
            image: compressedBase64, // Store the compressed base64 image
            description: desc,
            options: selectedOptionsString,
            uploaded: "Customer",
            date: currentDateTime,
          },
        ]);

        // Reset fields
        toggle();
        setImage(null);
        setDesc("");
        setSelectedItem("");
        setUpdatedButton(true);
      };

      // Handle errors during FileReader
      reader.onerror = () => {
        console.error("Error reading compressed image Blob:", reader.error);
        toast.error("Failed to process compressed image. Please try again.");
      };
    } catch (error) {
      console.error("Image compression failed:", error);
      toast.error("Failed to compress image. Please try again.");
    }
  };


  return (
    <Modal show={show} onHide={toggle}>
      <Modal.Header closeButton>
        <h5 className="text-center text-danger">Upload Image</h5>
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
          <Form.Label htmlFor="item">Image For</Form.Label>
          <Form.Select
            id="item"
            onChange={(e) => setSelectedItem(e.target.value)}
            value={selectedItem}
            className="mb-3"
          >
            <option value="" hidden>
              Select Item
            </option>
            {itemsArr.map((itemObj) => (
              <option key={itemObj?.itemData?.id} value={itemObj?.itemData?.id}>
                {itemObj?.itemData?.item}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
        <Form.Group className="my-2">
          <Form.Label htmlFor="image">Image</Form.Label>
          <Form.Control
            id="image"
            type="file"
            onChange={handleImageChange}
            required
          />
        </Form.Group>
        {/* Checkboxes for multiple options */}
        <Form.Group className="my-3">
          <Form.Label>Options</Form.Label>
          <div className="checkbox-group horizontal-checkboxes">
            {[
              "Piping",
              "Golden Piping",
              "Self Piping",
              "Contrast Piping",
              "Silver Piping",
              "Copper Piping",
              "Thread Work",
              "Beeds Work",
              "Knot Work",
              "Jardosi work",
              "Machine Work",
              "Flat Work",
              "Crop Top",
              "Front Open",
              "Back Open",
              "Side Open",
              "Back",
              "Front",
              "Sleeves",
            ].map((option) => (
              <Form.Check
                key={option}
                type="checkbox"
                label={option}
                value={option}
                onChange={handleCheckboxChange}
                inline
              />
            ))}
          </div>
        </Form.Group>
        <Form.Group className="my-2">
          <Form.Label htmlFor="desc">Image Description</Form.Label>
          <Form.Control
            id="desc"
            type="textarea"
            values={desc}
            onChange={(e) => setDesc(e.target.value)}
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={toggle}>
          Close
        </Button>
        <Button variant="danger" onClick={handleClick}>
          Add
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
